import { render, staticRenderFns } from "./PanelWithJobEditor.vue?vue&type=template&id=184b1958&lang=pug&"
import script from "./PanelWithJobEditor.vue?vue&type=script&lang=ts&"
export * from "./PanelWithJobEditor.vue?vue&type=script&lang=ts&"
import style0 from "./PanelWithJobEditor.vue?vue&type=style&index=0&id=184b1958&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports